import type { ChartData, DashboardOptions } from '@/entities/dashboard';

const MOVEMENTS_STACK = 'movements';

/**
 * Stock movements the way legacy RITA drew them: one column a day, every
 * movement type stacked in it — receipts above the axis, outgoing stock below.
 *
 * The API files the series under three stacks — receipts and dispatches,
 * releases, losses — which ECharts draws as three columns sharing one day's
 * slot, each a third as wide.
 *
 * Unlike the other date charts, the days nothing moved on are not filled back
 * in (`fillDateCategories`, 353356): legacy put only the days a movement was
 * booked on the axis, and half a year of mostly empty days left every column a
 * sliver (360306). The week flag that filling would have set is set here.
 */
export const toMovementsColumns = (data: ChartData, group: DashboardOptions['group']): ChartData => ({
  ...data,
  weekly: group === 'W',
  series: data.series.map((series) => ({ ...series, stack: MOVEMENTS_STACK }))
});
